import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/launch',
    name: 'launch',
    component: () => import('@/views/LaunchView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/views/CallbackView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'inbox',
    component: () => import('@/views/InboxView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/message/:id',
    name: 'message-detail',
    component: () => import('@/views/MessageDetailView.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/results',
    name: 'results',
    component: () => import('@/views/ResultsFollowUpView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/HelpView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/deployment',
    name: 'deployment',
    component: () => import('@/views/DeploymentGuideView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

// Navigation guard for authentication
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Wait for auth initialization if still loading
  if (authStore.isLoading) {
    await authStore.initializeAuth()
  }

  // Check if route requires authentication
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // Store intended destination for redirect after auth
    sessionStorage.setItem('paraclete-redirect-after-auth', to.fullPath)

    // Check if we have a stored SMART context to resume
    const storedClient = sessionStorage.getItem('SMART_CLIENT_STATE')
    if (storedClient) {
      // Try to restore the session
      await authStore.restoreSession()
      if (authStore.isAuthenticated) {
        next()
        return
      }
    }

    // Redirect to launch if no valid session
    next({ name: 'launch' })
    return
  }

  next()
})

export default router
